import { Images } from '../../utils/images.utils';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'dp-sub-header-normal',
    templateUrl: './sub-header-normal.component.html',
    styleUrls: ['./sub-header-normal.component.scss'],
    // animations: [slide]
})
export class SubHeaderNormalComponent {
    public back = Images.BACK;
    @Input() public title: string;
    @Input() public routeBack: string;

    constructor(private router: Router, private location: Location) {}

    public comeBack() {
        if (this.routeBack) {
            this.router.navigate([this.routeBack]);
        } else {
            this.location.back();
        }
    }
}
